import React, { useState } from "react";
// Customizable Area Start
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Drawer from '@material-ui/core/Drawer';
import Menu from "./Menu";

export default function NewHeader({ navigation, userData }: { navigation: any, userData: any }) {
  const getMsg = JSON.parse(localStorage.getItem("FirebaseMsg") || '{}')
  const [state, setState] = useState<any>({
    left: false,
  });

  const toggleDrawer = (anchor: any, open: any) => (event: any) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  return (
    <View style={styles.header}>
      {['left'].map((anchor: any) => (
        <React.Fragment key={anchor}>
          <MenuIcon style={{ color: '#fff', fontSize: 30 }} onClick={toggleDrawer(anchor, true)} />
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            <Menu userData={userData} navigation={navigation} state={setState} />
          </Drawer>
        </React.Fragment>
      ))}
      <Text style={styles.headerText}>Dashboard </Text>
      <TouchableOpacity onPress={() => navigation.navigate("Notification")}>
        <NotificationsIcon style={{ fontSize: 30, color: '#fff' }} />
        {Object.keys(getMsg).length ? <Text style={styles.popup}></Text> : null}
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    paddingVertical: 15
  },
  headerText: {
    color: '#e8fafe',
    fontSize: 18
  },
  popup: {
    borderRadius: 3,
    right: 5.5,
    top: 5,
    padding: 5,
    position: 'absolute',
    backgroundColor: 'green'
  }
})
// Customizable Area End
